import React from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col, Card, Button } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';
import { useSelector } from 'react-redux';

import SimpleMantenedorLayout from '../../components/SimpleMantenedorLayout';
import { useMantenedores } from '../../context/MantenedoresContext';

const Generales = () => {
  const history = useHistory();
  const user = useSelector(state => state.auth.user);
  const { userPermissions } = useMantenedores();
  const permisos = userPermissions?.modules?.generales || {};

  // Navegar a los submódulos
  const navigateToTipoFlota = () => {
    history.push('/mantenedores/generales/tipo-flota');
  };

  const navigateToCentroDespachos = () => {
    history.push('/mantenedores/generales/centro-despachos');
  };

  const navigateToTMS = () => {
    history.push('/mantenedores/generales/tms');
  };

  const navigateToTiposDocumento = () => {
    history.push('/mantenedores/generales/tipos-documento');
  };

  const navigateToComunas = () => {
    history.push('/mantenedores/generales/comunas');
  };

  const navigateToRegiones = () => {
    history.push('/mantenedores/generales/regiones');
  };

  const navigateToServicioSpread = () => {
    history.push('/mantenedores/generales/servicio-spread');
  };

  const navigateToTamanoSpread = () => {
    history.push('/mantenedores/generales/tamano-spread');
  };

  const navigateToLocalCliente = () => {
    history.push('/mantenedores/generales/local-cliente');
  };

  const navigateToTamanoCliente = () => {
    history.push('/mantenedores/generales/tamano-cliente');
  };

  const navigateToBanco = () => {
    history.push('/mantenedores/generales/banco');
  };

  const navigateToTipoCuenta = () => {
    history.push('/mantenedores/generales/tipo-cuenta');
  };

  const navigateToClientes = () => {
    history.push('/mantenedores/generales/clientes');
  };

  return (
    <SimpleMantenedorLayout
      mantenedorId="generales"
      title="Mantenedor de Generales"
      subtitle="Gestión de configuraciones generales del sistema"
      iconColor="#6f42c1"
      breadcrumbs={[{ label: 'Generales' }]}
      showBackButton={false}
    >
      <Row className="mt-4">
        <Col xs={12}>
          <div style={{ marginBottom: '24px' }}>
            <h4 style={{ color: '#212529', marginBottom: '8px' }}>
              Configuraciones Generales
            </h4>
            <p style={{ color: '#6c757d', marginBottom: '0' }}>
              Selecciona el tipo de configuración que deseas gestionar
            </p>
          </div>
        </Col>
      </Row>

      <Row className="g-4">
        {/* Submódulo Tipo Flota */}
        <Col xs={12} md={6} lg={4}>
          <Card 
            className="h-100 shadow-sm border-0"
            style={{ 
              cursor: permisos.canView ? 'pointer' : 'not-allowed',
              opacity: permisos.canView ? 1 : 0.6,
              transition: 'all 0.3s ease'
            }}
            onClick={permisos.canView ? navigateToTipoFlota : undefined}
          >
            <Card.Body className="d-flex flex-column align-items-center text-center p-4">
              <div 
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#e3f2fd',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}
              >
                <FaIcons.FaTruck 
                  style={{ 
                    fontSize: '2rem', 
                    color: '#1976d2' 
                  }} 
                />
              </div>
              
              <h5 style={{ color: '#212529', marginBottom: '12px' }}>
                Tipo Flota
              </h5>
              
              <p style={{ 
                color: '#6c757d', 
                marginBottom: '20px',
                fontSize: '0.95rem',
                lineHeight: '1.5'
              }}>
                Gestiona los tipos de flota disponibles: colaborativa, propia, eléctrico, etc.
              </p>
              
              <div className="mt-auto">
                <Button
                  variant="outline-primary"
                  size="sm"
                  disabled={!permisos.canView}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (permisos.canView) navigateToTipoFlota();
                  }}
                >
                  <FaIcons.FaArrowRight className="me-2" />
                  Gestionar
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Submódulo Centro Despachos */}
        <Col xs={12} md={6} lg={4}>
          <Card 
            className="h-100 shadow-sm border-0"
            style={{ 
              cursor: permisos.canView ? 'pointer' : 'not-allowed',
              opacity: permisos.canView ? 1 : 0.6,
              transition: 'all 0.3s ease'
            }}
            onClick={permisos.canView ? navigateToCentroDespachos : undefined}
          >
            <Card.Body className="d-flex flex-column align-items-center text-center p-4">
              <div 
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#f3e5f5',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}
              >
                <FaIcons.FaWarehouse 
                  style={{ 
                    fontSize: '2rem', 
                    color: '#7b1fa2' 
                  }} 
                />
              </div>
              
              <h5 style={{ color: '#212529', marginBottom: '12px' }}>
                Centro Despachos
              </h5>
              
              <p style={{ 
                color: '#6c757d', 
                marginBottom: '20px',
                fontSize: '0.95rem',
                lineHeight: '1.5'
              }}>
                Administra los centros de despacho y su asignación por comunas
              </p>
              
              <div className="mt-auto">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  disabled={!permisos.canView}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (permisos.canView) navigateToCentroDespachos();
                  }}
                >
                  <FaIcons.FaArrowRight className="me-2" />
                  Gestionar
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Submódulo TMS */}
        <Col xs={12} md={6} lg={4}>
          <Card 
            className="h-100 shadow-sm border-0"
            style={{ 
              cursor: permisos.canView ? 'pointer' : 'not-allowed',
              opacity: permisos.canView ? 1 : 0.6,
              transition: 'all 0.3s ease'
            }}
            onClick={permisos.canView ? navigateToTMS : undefined}
          >
            <Card.Body className="d-flex flex-column align-items-center text-center p-4">
              <div 
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#e8f5e8',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}
              >
                <FaIcons.FaCogs 
                  style={{ 
                    fontSize: '2rem', 
                    color: '#388e3c' 
                  }} 
                />
              </div>
              
              <h5 style={{ color: '#212529', marginBottom: '12px' }}>
                TMS
              </h5>
              
              <p style={{ 
                color: '#6c757d', 
                marginBottom: '20px',
                fontSize: '0.95rem',
                lineHeight: '1.5'
              }}>
                Configura los sistemas TMS disponibles: GeoSort, DispatchTrack, etc.
              </p>
              
              <div className="mt-auto">
                <Button
                  variant="outline-success"
                  size="sm"
                  disabled={!permisos.canView}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (permisos.canView) navigateToTMS();
                  }}
                >
                  <FaIcons.FaArrowRight className="me-2" />
                  Gestionar
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Submódulo Tipos de Documento */}
        <Col xs={12} md={6} lg={4}>
          <Card 
            className="h-100 shadow-sm border-0"
            style={{ 
              cursor: permisos.canView ? 'pointer' : 'not-allowed',
              opacity: permisos.canView ? 1 : 0.6,
              transition: 'all 0.3s ease'
            }}
            onClick={permisos.canView ? navigateToTiposDocumento : undefined}
          >
            <Card.Body className="d-flex flex-column align-items-center text-center p-4">
              <div 
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#fff3e0',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}
              >
                <FaIcons.FaFileAlt 
                  style={{ 
                    fontSize: '2rem', 
                    color: '#f57c00' 
                  }} 
                />
              </div>
              
              <h5 style={{ color: '#212529', marginBottom: '12px' }}>
                Tipos de Documento
              </h5>
              
              <p style={{ 
                color: '#6c757d', 
                marginBottom: '20px',
                fontSize: '0.95rem',
                lineHeight: '1.5'
              }}>
                Gestiona los tipos de documento disponibles: boletas, facturas, etc.
              </p>
              
              <div className="mt-auto">
                <Button
                  variant="outline-warning"
                  size="sm"
                  disabled={!permisos.canView}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (permisos.canView) navigateToTiposDocumento();
                  }}
                >
                  <FaIcons.FaArrowRight className="me-2" />
                  Gestionar
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Submódulo Comunas */}
        <Col xs={12} md={6} lg={4}>
          <Card 
            className="h-100 shadow-sm border-0"
            style={{ 
              cursor: permisos.canView ? 'pointer' : 'not-allowed',
              opacity: permisos.canView ? 1 : 0.6,
              transition: 'all 0.3s ease'
            }}
            onClick={permisos.canView ? navigateToComunas : undefined}
          >
            <Card.Body className="d-flex flex-column align-items-center text-center p-4">
              <div 
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#e1f5fe',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}
              >
                <FaIcons.FaMapMarkerAlt 
                  style={{ 
                    fontSize: '2rem', 
                    color: '#0277bd' 
                  }} 
                />
              </div>
              
              <h5 style={{ color: '#212529', marginBottom: '12px' }}>
                Comunas
              </h5>
              
              <p style={{ 
                color: '#6c757d', 
                marginBottom: '20px',
                fontSize: '0.95rem',
                lineHeight: '1.5'
              }}>
                Administra las comunas disponibles del sistema
              </p>
              
              <div className="mt-auto">
                <Button
                  variant="outline-info"
                  size="sm"
                  disabled={!permisos.canView}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (permisos.canView) navigateToComunas();
                  }}
                >
                  <FaIcons.FaArrowRight className="me-2" />
                  Gestionar
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Submódulo Regiones */}
        <Col xs={12} md={6} lg={4}>
          <Card 
            className="h-100 shadow-sm border-0"
            style={{ 
              cursor: permisos.canView ? 'pointer' : 'not-allowed',
              opacity: permisos.canView ? 1 : 0.6,
              transition: 'all 0.3s ease'
            }}
            onClick={permisos.canView ? navigateToRegiones : undefined}
          >
            <Card.Body className="d-flex flex-column align-items-center text-center p-4">
              <div 
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#f3e5f5',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}
              >
                <FaIcons.FaGlobeAmericas 
                  style={{ 
                    fontSize: '2rem', 
                    color: '#8e24aa' 
                  }} 
                />
              </div>
              
              <h5 style={{ color: '#212529', marginBottom: '12px' }}>
                Regiones
              </h5>
              
              <p style={{ 
                color: '#6c757d', 
                marginBottom: '20px',
                fontSize: '0.95rem',
                lineHeight: '1.5'
              }}>
                Gestiona las regiones disponibles del país
              </p>
              
              <div className="mt-auto">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  disabled={!permisos.canView}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (permisos.canView) navigateToRegiones();
                  }}
                >
                  <FaIcons.FaArrowRight className="me-2" />
                  Gestionar
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Submódulo Servicio Spread */}
        <Col xs={12} md={6} lg={4}>
          <Card 
            className="h-100 shadow-sm border-0"
            style={{ 
              cursor: permisos.canView ? 'pointer' : 'not-allowed',
              opacity: permisos.canView ? 1 : 0.6,
              transition: 'all 0.3s ease'
            }}
            onClick={permisos.canView ? navigateToServicioSpread : undefined}
          >
            <Card.Body className="d-flex flex-column align-items-center text-center p-4">
              <div 
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#e8f5e8',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}
              >
                <FaIcons.FaServicestack 
                  style={{ 
                    fontSize: '2rem', 
                    color: '#43a047' 
                  }} 
                />
              </div>
              
              <h5 style={{ color: '#212529', marginBottom: '12px' }}>
                Servicio Spread
              </h5>
              
              <p style={{ 
                color: '#6c757d', 
                marginBottom: '20px',
                fontSize: '0.95rem',
                lineHeight: '1.5'
              }}>
                Configura los servicios de Spread disponibles
              </p>
              
              <div className="mt-auto">
                <Button
                  variant="outline-success"
                  size="sm"
                  disabled={!permisos.canView}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (permisos.canView) navigateToServicioSpread();
                  }}
                >
                  <FaIcons.FaArrowRight className="me-2" />
                  Gestionar
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Submódulo Tamaño Spread */}
        <Col xs={12} md={6} lg={4}>
          <Card 
            className="h-100 shadow-sm border-0"
            style={{ 
              cursor: permisos.canView ? 'pointer' : 'not-allowed',
              opacity: permisos.canView ? 1 : 0.6,
              transition: 'all 0.3s ease'
            }}
            onClick={permisos.canView ? navigateToTamanoSpread : undefined}
          >
            <Card.Body className="d-flex flex-column align-items-center text-center p-4">
              <div 
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#fce4ec',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}
              >
                <FaIcons.FaRulerCombined 
                  style={{ 
                    fontSize: '2rem', 
                    color: '#e91e63' 
                  }} 
                />
              </div>
              
              <h5 style={{ color: '#212529', marginBottom: '12px' }}>
                Tamaño Spread
              </h5>
              
              <p style={{ 
                color: '#6c757d', 
                marginBottom: '20px',
                fontSize: '0.95rem',
                lineHeight: '1.5'
              }}>
                Gestiona los tamaños de Spread: pequeño, mediano, grande
              </p>
              
              <div className="mt-auto">
                <Button
                  variant="outline-danger"
                  size="sm"
                  disabled={!permisos.canView}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (permisos.canView) navigateToTamanoSpread();
                  }}
                >
                  <FaIcons.FaArrowRight className="me-2" />
                  Gestionar
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Submódulo Local Cliente */}
        <Col xs={12} md={6} lg={4}>
          <Card 
            className="h-100 shadow-sm border-0"
            style={{ 
              cursor: permisos.canView ? 'pointer' : 'not-allowed',
              opacity: permisos.canView ? 1 : 0.6,
              transition: 'all 0.3s ease'
            }}
            onClick={permisos.canView ? navigateToLocalCliente : undefined}
          >
            <Card.Body className="d-flex flex-column align-items-center text-center p-4">
              <div 
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#fff8e1',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}
              >
                <FaIcons.FaStore 
                  style={{ 
                    fontSize: '2rem', 
                    color: '#ffb300' 
                  }} 
                />
              </div>
              
              <h5 style={{ color: '#212529', marginBottom: '12px' }}>
                Local Cliente
              </h5>
              
              <p style={{ 
                color: '#6c757d', 
                marginBottom: '20px',
                fontSize: '0.95rem',
                lineHeight: '1.5'
              }}>
                Administra los locales y tiendas de clientes
              </p>
              
              <div className="mt-auto">
                <Button
                  variant="outline-warning"
                  size="sm"
                  disabled={!permisos.canView}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (permisos.canView) navigateToLocalCliente();
                  }}
                >
                  <FaIcons.FaArrowRight className="me-2" />
                  Gestionar
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Submódulo Tamaño Cliente */}
        <Col xs={12} md={6} lg={4}>
          <Card 
            className="h-100 shadow-sm border-0"
            style={{ 
              cursor: permisos.canView ? 'pointer' : 'not-allowed',
              opacity: permisos.canView ? 1 : 0.6,
              transition: 'all 0.3s ease'
            }}
            onClick={permisos.canView ? navigateToTamanoCliente : undefined}
          >
            <Card.Body className="d-flex flex-column align-items-center text-center p-4">
              <div 
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#f1f8e9',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}
              >
                <FaIcons.FaUsers 
                  style={{ 
                    fontSize: '2rem', 
                    color: '#689f38' 
                  }} 
                />
              </div>
              
              <h5 style={{ color: '#212529', marginBottom: '12px' }}>
                Tamaño Cliente
              </h5>
              
              <p style={{ 
                color: '#6c757d', 
                marginBottom: '20px',
                fontSize: '0.95rem',
                lineHeight: '1.5'
              }}>
                Configura los tamaños de cliente: micro, pequeña, mediana, grande empresa
              </p>
              
              <div className="mt-auto">
                <Button
                  variant="outline-success"
                  size="sm"
                  disabled={!permisos.canView}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (permisos.canView) navigateToTamanoCliente();
                  }}
                >
                  <FaIcons.FaArrowRight className="me-2" />
                  Gestionar
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Submódulo Banco */}
        <Col xs={12} md={6} lg={4}>
          <Card 
            className="h-100 shadow-sm border-0"
            style={{ 
              cursor: permisos.canView ? 'pointer' : 'not-allowed',
              opacity: permisos.canView ? 1 : 0.6,
              transition: 'all 0.3s ease'
            }}
            onClick={permisos.canView ? navigateToBanco : undefined}
          >
            <Card.Body className="d-flex flex-column align-items-center text-center p-4">
              <div 
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#e3f2fd',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}
              >
                <FaIcons.FaUniversity 
                  style={{ 
                    fontSize: '2rem', 
                    color: '#1565c0' 
                  }} 
                />
              </div>
              
              <h5 style={{ color: '#212529', marginBottom: '12px' }}>
                Banco
              </h5>
              
              <p style={{ 
                color: '#6c757d', 
                marginBottom: '20px',
                fontSize: '0.95rem',
                lineHeight: '1.5'
              }}>
                Gestiona los bancos disponibles del sistema financiero
              </p>
              
              <div className="mt-auto">
                <Button
                  variant="outline-primary"
                  size="sm"
                  disabled={!permisos.canView}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (permisos.canView) navigateToBanco();
                  }}
                >
                  <FaIcons.FaArrowRight className="me-2" />
                  Gestionar
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Submódulo Tipo Cuenta */}
        <Col xs={12} md={6} lg={4}>
          <Card 
            className="h-100 shadow-sm border-0"
            style={{ 
              cursor: permisos.canView ? 'pointer' : 'not-allowed',
              opacity: permisos.canView ? 1 : 0.6,
              transition: 'all 0.3s ease'
            }}
            onClick={permisos.canView ? navigateToTipoCuenta : undefined}
          >
            <Card.Body className="d-flex flex-column align-items-center text-center p-4">
              <div 
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#fafafa',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}
              >
                <FaIcons.FaCreditCard 
                  style={{ 
                    fontSize: '2rem', 
                    color: '#424242' 
                  }} 
                />
              </div>
              
              <h5 style={{ color: '#212529', marginBottom: '12px' }}>
                Tipo Cuenta
              </h5>
              
              <p style={{ 
                color: '#6c757d', 
                marginBottom: '20px',
                fontSize: '0.95rem',
                lineHeight: '1.5'
              }}>
                Configura los tipos de cuenta bancaria: corriente, vista, ahorro
              </p>
              
              <div className="mt-auto">
                <Button
                  variant="outline-dark"
                  size="sm"
                  disabled={!permisos.canView}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (permisos.canView) navigateToTipoCuenta();
                  }}
                >
                  <FaIcons.FaArrowRight className="me-2" />
                  Gestionar
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Submódulo Clientes */}
        <Col xs={12} md={6} lg={4}>
          <Card 
            className="h-100 shadow-sm border-0"
            style={{ 
              cursor: permisos.canView ? 'pointer' : 'not-allowed',
              opacity: permisos.canView ? 1 : 0.6,
              transition: 'all 0.3s ease'
            }}
            onClick={permisos.canView ? navigateToClientes : undefined}
          >
            <Card.Body className="d-flex flex-column align-items-center text-center p-4">
              <div 
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#e3f2fd',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}
              >
                <FaIcons.FaBuilding 
                  style={{ 
                    fontSize: '2rem', 
                    color: '#0d6efd' 
                  }} 
                />
              </div>
              
              <h5 style={{ color: '#212529', marginBottom: '12px' }}>
                Clientes
              </h5>
              
              <p style={{ 
                color: '#6c757d', 
                marginBottom: '20px',
                fontSize: '0.95rem',
                lineHeight: '1.5'
              }}>
                Administra el catálogo de clientes del sistema
              </p>
              
              <div className="mt-auto">
                <Button
                  variant="outline-primary"
                  size="sm"
                  disabled={!permisos.canView}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (permisos.canView) navigateToClientes();
                  }}
                >
                  <FaIcons.FaArrowRight className="me-2" />
                  Gestionar
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </SimpleMantenedorLayout>
  );
};

export default Generales;
